var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import NotificationBar from 'syf-component-library/ui/patterns/NotificationBar';
var CollapsedNotification = styled(NotificationBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* This will visually fuse the notification to its previous sibling element */\n  /* Needs custom value for pixel perfection*/\n  margin-top: -10px;\n  padding-top: ", "px;\n"], ["\n  /* This will visually fuse the notification to its previous sibling element */\n  /* Needs custom value for pixel perfection*/\n  margin-top: -10px;\n  padding-top: ", "px;\n"])), spacing.small);
var CollapsedCardNotification = function (_a) {
    var notificationList = _a.notificationList;
    var notificationData = notificationList.length && notificationList[0].name;
    if (notificationData !== 'pastDueNotify' &&
        notificationData !== 'attentionRequiredNotify')
        return null;
    var _b = notificationList[0], notificationType = _b.notificationType, notificationIcon = _b.notificationIcon, description = _b.description, subDescription = _b.subDescription, _c = _b.fontAwesomeType, fontAwesomeType = _c === void 0 ? 'far' : _c;
    return (_jsx(CollapsedNotification, { type: notificationType, icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon] }), title: description, subTitle: subDescription }));
};
export default CollapsedCardNotification;
var templateObject_1;
